export default __webpack_public_path__ + "static/media/investors_logo4.476f5bf0.png";